// react
import React, { useState, useEffect } from "react";

// react-router-dom
import { Navigate, useParams } from "react-router-dom";

// context
import { UserAuth } from "context/AuthContext";

// firebase
import { requestPermission } from "config/firebase";

// features/user
import addFCMToken from "features/user/addFCMToken";
import isUserAuthorizedForDataBox from "features/user/isUserAuthorizedForDataBox";
import isUserAuthorizedForDataBoxReadOnly from "features/user/isUserAuthorizedForDataBoxReadOnly";

// A ---------------------------------------------------------------------- M

const RequireAuthAndAccess = ({ children }) => {
  const { user } = UserAuth();
  const { tag } = useParams();

  const [allowed, setAllowed] = useState(null);

  useEffect(() => {
    const handleFCMToken = async () => {
      const token = await requestPermission();
      if (token) await addFCMToken(user.uid, token);
    };

    const checkAccess = async () => {
      if (!user) {
        setAllowed(false);
        return;
      }

      await handleFCMToken();

      if (!tag) {
        setAllowed(true);
        return;
      }

      const isTagGroupMember = await isUserAuthorizedForDataBox(tag, user.uid);
      const isTagGroupMemberReadOnly = await isUserAuthorizedForDataBoxReadOnly(tag, user.uid);

      setAllowed(isTagGroupMember || isTagGroupMemberReadOnly);
    };

    checkAccess();
  }, [user, tag]);

  if (allowed === null) {
    return null;
  } else if (allowed) {
    return children;
  } else if (tag) {
    return <Navigate to={`/${tag}/public`} state={{ tag: tag }} />;
  } else {
    return <Navigate to="/signin" state={{ tag: tag }} />;
  }
};

export default RequireAuthAndAccess;
